export default {
  cantFindAddress: 'Can not Find Address ?',
  confirmLocation: 'Confirm location',
  noResultFound: 'No Result Found!'
};